import { CodeCerfa } from '../scenarii';

export const hasSuspension = (store) => {
    const { subscriber, cerfa } = store || {};
    const TPA_SUBSCRIBER_CODES = process.env.REACT_APP_TPA_SUBSCRIBER_CODES ? process.env.REACT_APP_TPA_SUBSCRIBER_CODES.split(',') : [];

    const hasSubscriberTpa = subscriber?.cod && TPA_SUBSCRIBER_CODES.includes(subscriber.cod);
    const isCerfaExcluded = cerfa === CodeCerfa.S3202;

    return hasSubscriberTpa && !isCerfaExcluded;
};
